<template>
  <!-- Click-through overlay above the header and drawer, below menus and dialogs -->
  <div
    v-if="environment"
    class="tw-pointer-events-none tw-fixed tw-inset-x-0 tw-top-0 tw-z-[5000]"
    data-testid="environment-indicator"
  >
    <span class="tw-sr-only" data-testid="environment-sr-label">
      {{ environment.label }} environment
    </span>
    <div :class="`bg-${environment.color}`" class="tw-h-1.5" />
    <div
      aria-hidden="true"
      :class="`bg-${environment.color}`"
      class="tw-absolute tw-inset-x-0 tw-top-0 tw-mx-auto tw-hidden tw-w-fit tw-items-center tw-gap-1 tw-rounded-b-md tw-px-3 tw-pb-1 tw-pt-1.5 tw-text-sm tw-font-bold tw-tracking-widest tw-text-white tw-shadow-md md:tw-flex"
      data-testid="environment-label"
    >
      <q-icon name="science" size="16px" />
      {{ environment.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
// Production builds have no entry, so nothing is flagged there
const environments: Record<string, { label: string; color: string }> = {
  local: { label: 'LOCAL', color: 'teal-7' },
  dev: { label: 'DEV', color: 'orange-9' },
  uat: { label: 'UAT', color: 'purple-7' },
};

const environment = environments[process.env.DLA_ENV ?? ''];
</script>
